import React from "react";
import {
  DEAL_PARTNER_STATUS_ACCEPTED,
  DEAL_PARTNER_STATUS_DECLINED
} from "../deal/Constants";

import { Alert } from "reactstrap";

const PartnerAcceptDealAlert = props => {
  return (
    <div className="alerts-wrapper">
      <Alert
        color="dark-info"
        className={"d-flex align-items-center justify-content-stretch"}
      >
        <p className="mb-0 font-weight-bold mr-auto text-white">
          Would you like to accept this deal?
        </p>
        <div className="btn-wrapper ml-auto mr-0">
          <button
            id={props.id}
            type="button"
            className="btn btn-danger mr-4 text-white"
            onClick={() =>
              props.updatePartnerDealStatus(
                DEAL_PARTNER_STATUS_DECLINED,
                props.dealDetails.id
              )
            }
          >
            No, I Reject!
          </button>
          <button
            id={props.id}
            type="button"
            className="btn btn-success"
            onClick={() =>
              props.updatePartnerDealStatus(
                DEAL_PARTNER_STATUS_ACCEPTED,
                props.dealDetails.id
              )
            }
          >
            Yes, I Accept!
          </button>
        </div>
      </Alert>
    </div>
  );
};

export default PartnerAcceptDealAlert;
